import { render, staticRenderFns } from "./TableChange.vue?vue&type=template&id=c2ec0082&"
import script from "./TableChange.vue?vue&type=script&lang=js&"
export * from "./TableChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports